
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { store } from "../store/mainStore";

@Component
export default class Empresa extends Vue {
  heightCabecalho: any = null;

  mounted() {
    this.getAlturaCabecalho();
  }

  scrollToLocalizacao() {
    let elemento = this.$refs.organizacional as any;
    elemento.scrollIntoView();
  }
  
  scrollToTrabConosco() {
    let elemento = this.$refs.localizacao as any;
    elemento.scrollIntoView();
  }
  // OBTEM DA STORE O VALOR DA ALTURA DO CABECALHO
  getAlturaCabecalho() {
    this.heightCabecalho = this.$store.state.alturaCabecalho;
    // console.log(this.heightCabecalho);
  }
}
